// extracted by mini-css-extract-plugin
export default {"dots":"DotLoader_dots__zVQ2q","dots-7ar3yq":"DotLoader_dots-7ar3yq__UNtKp"};